<template>
  <div class="login-root">
    <div class="login-scroll-container">
      <div class="login-content-wrapper">
        <div class="fonts-white">
          
          <!-- Logo Section -->
          <div class="logo-section">
            <LogoWhite @click="handleClickMenu('muzible')" class="logo-clickable"></LogoWhite>
          </div>

          <!-- Typing Animation Header -->
          <div class="typing-section">
            <div class="typing-container">
              <div class="fonts-head typing-text" id="feature-text">
                {{ dynamicText }}
                <span class="cursor"></span>
              </div>
            </div>
          </div>

          <!-- Login Card -->
          <div class="login-card-section">
            <div class="login-card">
              <v-card class="login-form-card">
                <v-card-text class="login-form-content">
                  <v-form ref="formlogin" v-model="validLogin" id="check-login-form">
                    <v-text-field 
                      v-model="emailLogin" 
                      class="email-font mb-4" 
                      :rules="emailRulesLogin"
                      label="ENTER EMAIL" 
                      required 
                      color="#1ff050" 
                      @focus="checkErrors()"
                      :error-messages="emailValidationLoginErrors"
                      variant="outlined"
                      density="comfortable"
                    ></v-text-field>
                    
                    <v-text-field 
                      autocomplete="current-password" 
                      class="password-font mb-4"
                      v-model.lazy="passLogin" 
                      :rules="passwordRulesLogin" 
                      label="ENTER PASSWORD"
                      :append-inner-icon="value ? 'mdi-eye' : 'mdi-eye-off'" 
                      @click:append-inner="() => (value = !value)"
                      :type="value ? 'password' : 'text'" 
                      @input="passLogin = $event.target.value" 
                      @focus="checkErrors()"
                      required 
                      color="#1ff050"
                      variant="outlined"
                      density="comfortable"
                    ></v-text-field>
                    
                    <div class="forgot-password-section pb-2">
                      <span class="link-accept-signup" @click="handleClickMenu('forgot')">
                        Forgot Password
                      </span>
                    </div>
                  </v-form>

                  <!-- Error Message -->
                  <div v-if="this.loginerror !== ''" class="error-section">
                    <v-alert type="error" density="compact" class="login-error-alert">
                      <span class="blink">{{ this.loginerror }}</span>
                    </v-alert>
                  </div>

                  <!-- Login Button -->
                  <div class="button-section">
                    <v-btn 
                      type="submit" 
                      form="check-login-form" 
                      :disabled="!validLogin" 
                      color="#000000"
                      variant="outlined"
                      class="login-btn"
                      size="large"
                      block
                      @click="login($event)"
                    >
                      <v-icon left>mdi-login</v-icon>
                      <span>Log in</span>
                    </v-btn>
                  </div>

                  <!-- Sign Up Link -->
                  <div class="signup-link-section">
                    <span class="sign-up-text-policy">
                      Not a member?
                      <span class="link-accept-signup" @click="handleClickMenu('signup')">
                        Sign up
                      </span>
                    </span>
                  </div>
                </v-card-text>
              </v-card>

              <!-- Footer Links -->
              <div class="footer-links">
                <div class="footer-buttons-container">
                  <button 
                    class="footer-link-btn"
                    @click="handleClickMenu('Terms')"
                  >
                    <v-icon size="14" class="footer-link-icon">mdi-file-document-outline</v-icon>
                    <span>Terms of use</span>
                  </button>
                  
                  <div class="separator-dot"></div>
                  
                  <button 
                    class="footer-link-btn"
                    @click="handleClickMenu('Privacy')"
                  >
                    <v-icon size="14" class="footer-link-icon">mdi-shield-lock-outline</v-icon>
                    <span>Privacy policy</span>
                  </button>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
  </div>
</template>

<script>

import LogoWhite from '../components/logo_white.vue';

export default {
  name: 'Login',

  components: {
    LogoWhite
  },
  data: () => ({
    delay: 80,
    validLogin: false,
    emailLogin: '',
    passLogin: '',
    loginerror: '',
    emailValidationLoginErrors: [],
    passwordRules: [
      v => !!v || 'Password is required',
      v => (v && v.length >= 7) || 'Password must have 7+ characters',
      v => /(?=.*[A-Z])/.test(v) || 'Must have one uppercase character',
      v => /(?=.*\d)/.test(v) || 'Must have one number',
      v => /([!@#$%^&*])/.test(v) || 'Must have one special character [!@#$%^&*]'
    ],
    passwordRulesLogin: [
      v => !!v || 'Password is required',
      v => (v && v.length >= 7) || 'Password must have 7+ characters',
      v => /(?=.*[A-Z])/.test(v) || 'Must have one uppercase character',
      v => /(?=.*\d)/.test(v) || 'Must have one number',
      v => /([!@#$%^&*])/.test(v) || 'Must have one special character [!@#$%^&*]'
    ],
    value: true,
    dynamicText: '',
    text: 'Welcome back',
  }),
  mounted() {
    this.typeText(0);
  },
  beforeUnmount() {

  },
  destroyed() {
  },
  computed: {
    emailRulesLogin() {
      return [
        v => {
          this.emailValidationLoginErrors = [];
          this.loginerror = '';
          var val = !!v
          if (val) {
            return true
          } else {
            return 'E-mail is required'
          }
        },
        v => /.+@.+/.test(v) || 'E-mail must be valid',
        v => /(^.+@(\[?)[a-zA-Z0-9-.]+.([a-zA-Z]{2,3}|[0-9]{1,3})(]?)$)/.test(v) || 'E-mail must be valid',
        v => /^[a-zA-Z0-9!'#$%&*+\\/=?^_`{|}~-]+(?:\.[a-zA-Z0-9!'#$%&*+\\/=?^_`{|}~-]+)*@(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?\.)+[a-zA-Z]{2,}$/.test(v) || 'E-mail must be valid'
      ]
    },
  },
  created() {
    if (this.$refs.formlogin) {
      this.$refs.formlogin.resetValidation();
    }
    this.$store.dispatch('reset2fa')
  },
  methods: {
    login(e) {
      this.validLogin = false;
      this.emailLogin = this.emailLogin.trim()

      this.$store.dispatch('login', {
        email: this.emailLogin,
        pass: this.passLogin
      }
      ).then(response => {
        if (this.$store.getters.getauth2fa) {
          this.goto2fa();
        } else {
          this.gotorootdash();
        }
      }).catch(error => {
        if (!error.response) {
          this.emailValidationLoginErrors = ['Service is down.. Try again later!'];
          this.loginerror = 'Service is down.. Try again later!'
        } else {
          this.emailValidationLoginErrors = ['Log In failed..'];
          this.loginerror = 'Log In failed..'
        }
      });
      e.preventDefault()
    },
    gotorootdash() {
      if (this.$store.getters.getMuze) {
        window.location.href = 'https://muze.muzible.com';
      } else if (this.$store.getters.getNFT) {
        window.location.href = 'https://verse.muzible.com';
      } else {
        this.$router.push({ name: 'plan' });
      }
    },
    goto2fa() {
        this.$router.push({ name: 'auth2fa' });
    },
    async typeText(num) {
      let i = 0;
      while (i < this.text.length) {
        await this.waitForMs(this.delay);
        this.dynamicText += this.text[i];
        i++;
      }
      await this.waitForMs(2000);
      if (num === 0) {
        this.text = 'Log in or Sign up'
        this.dynamicText = '';
        this.typeText(1);
      } else if (num === 1) {
        this.text = 'Set strong password'
        this.dynamicText = '';
        this.typeText(2);
      } else if (num === 2) {
        this.text = 'Log in and have fun!'
        this.dynamicText = '';
        this.typeText(3);
      } else {
        await this.waitForMs(4000);
        this.dynamicText = '';
        this.text = 'Welcome back'
        this.typeText(0)
      }
    },
    waitForMs(ms) {
      return new Promise(resolve => setTimeout(resolve, ms));
    },
    handleClickMenu(link) {
      if (link === 'Terms') {
        window.open('https://muzible.com/terms', '_blank');
      } else if (link === 'Privacy') {
        window.open('https://muzible.com/privacy', '_blank');
      } else {
        if (this.$route.name !== link) {
          this.$router.push({ name: link });
        }
      }
    },
    checkErrors() {
      if (this.emailValidationLoginErrors.length != 0
        && (this.emailValidationLoginErrors[0] === 'Log In failed..' ||
          this.emailValidationLoginErrors[0] === 'Service is down.. Try again later!')) {
        if (this.passLogin != '' && this.emailLogin != '') {
          this.validLogin = true;
        }
        this.emailValidationLoginErrors = [];
        this.loginerror = '';
      }
    },

  },
}
</script>

<style lang="scss" scoped>
@use './css/styles.scss';

/* Login Root - Complete Override */
.login-root {
  position: fixed !important;
  top: 0 !important;
  left: 0 !important;
  width: 100vw !important;
  height: 100vh !important;
  height: 100dvh !important;
  overflow: hidden !important;
  z-index: 1 !important;
}

/* Login Scroll Container - Main Scrollable Area */
.login-scroll-container {
  position: absolute !important;
  top: 0 !important;
  left: 0 !important;
  width: 100% !important;
  height: 100% !important;
  overflow-x: hidden !important;
  overflow-y: auto !important;
  background: linear-gradient(145deg, rgba(0, 0, 0, 0.95), rgba(18, 18, 18, 0.95));
  
  /* Smooth scrolling */
  scroll-behavior: smooth;
  -webkit-overflow-scrolling: touch;
  
  /* Hide scrollbar for Chrome, Safari and Opera */
  &::-webkit-scrollbar {
    display: none;
  }
  
  /* Hide scrollbar for IE, Edge and Firefox */
  -ms-overflow-style: none;  /* IE and Edge */
  scrollbar-width: none;  /* Firefox */
}

/* Login Content Wrapper */
.login-content-wrapper {
  width: 100%;
  min-height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  padding: 40px 20px 60px 20px;
}

/* Logo Section */
.logo-section {
  display: flex;
  justify-content: center;
  margin-bottom: 32px;
}

.logo-clickable {
  cursor: pointer;
  transition: transform 0.3s ease, opacity 0.3s ease;
}

.logo-clickable:hover {
  transform: scale(1.05);
  opacity: 0.9;
}

/* Typing Section */
.typing-section {
  display: flex;
  justify-content: center;
  margin-bottom: 24px;
}

.typing-container {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 60px;
}

.typing-text {
  font-family: "Darker Grotesque", sans-serif;
  font-size: 32px;
  font-weight: 600;
  color: white;
  text-align: center;
}

.cursor {
  display: inline-block;
  width: 3px;
  height: 32px;
  background-color: white;
  margin-left: 4px;
  animation: blink 0.6s linear infinite alternate;
}

@keyframes blink {
  0% { opacity: 1; }
  40% { opacity: 1; }
  60% { opacity: 0; }
  100% { opacity: 0; }
}

/* Login Card Section */
.login-card-section {
  display: flex;
  justify-content: center;
  min-width: 370px;
  max-width: 500px;
}

.login-card {
  width: 100%;
  max-width: 500px;
  animation: slideIn 0.4s ease forwards;
}

@keyframes slideIn {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.login-form-card {
  background: linear-gradient(145deg, rgba(26, 26, 26, 0.95), rgba(18, 18, 18, 0.95)) !important;
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 16px;
  overflow: hidden;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.4);
  transition: all 0.3s ease;
}

.login-form-card:hover {
  border-color: rgba(255, 255, 255, 0.2);
  box-shadow: 0 12px 40px rgba(0, 0, 0, 0.5);
}

.login-form-content {
  padding: 32px 24px !important;
}

/* Error Section */
.error-section {
  margin-bottom: 16px;
}

/* Button Section */
.button-section {
  margin-bottom: 16px;
}

/* Signup Link Section */
.signup-link-section {
  display: flex;
  justify-content: center;
  margin-bottom: 8px;
}

/* Form Fields */
.email-font,
.password-font {
  font-family: "Darker Grotesque", sans-serif !important;
  font-size: 16px !important;
}

.email-font :deep(.v-field),
.password-font :deep(.v-field) {
  background: rgba(255, 255, 255, 0.05) !important;
  border-radius: 12px;
}

.email-font :deep(.v-field__outline),
.password-font :deep(.v-field__outline) {
  color: rgba(255, 255, 255, 0.2);
}

.email-font :deep(.v-field--focused .v-field__outline),
.password-font :deep(.v-field--focused .v-field__outline) {
  color: #1ff050 !important;
}

.email-font :deep(.v-field__input),
.password-font :deep(.v-field__input) {
  color: white !important;
}

.email-font :deep(.v-label),
.password-font :deep(.v-label) {
  color: rgba(255, 255, 255, 0.6) !important;
}

.email-font :deep(.v-field--focused .v-label),
.password-font :deep(.v-field--focused .v-label) {
  color: #1ff050 !important;
}

/* Forgot Password */
.forgot-password-section {
  display: flex;
  justify-content: flex-end;
}

/* Error Alert */
.login-error-alert {
  width: 100%;
  margin: 0 !important;
}

.login-error-alert .blink {
  -webkit-animation: blinkError 1.5s infinite both;
  animation: blinkError 1.5s infinite both;
}

@keyframes blinkError {
  0%, 100% { opacity: 1; }
  50% { opacity: 0.5; }
}

/* Login Button */
.login-btn {
  font-family: "Darker Grotesque", sans-serif !important;
  font-size: 18px !important;
  font-weight: 600 !important;
  text-transform: none !important;
  padding: 24px !important;
  border: 2px solid rgba(31, 240, 80, 0.5) !important;
  background: linear-gradient(135deg, rgba(31, 240, 80, 0.1) 0%, rgba(31, 240, 80, 0.05) 100%) !important;
  color: #1ff050 !important;
  transition: all 0.3s ease;
}

.login-btn:hover:not(:disabled) {
  border-color: rgba(31, 240, 80, 0.8) !important;
  background: linear-gradient(135deg, rgba(31, 240, 80, 0.2) 0%, rgba(31, 240, 80, 0.1) 100%) !important;
  transform: translateY(-2px);
  box-shadow: 0 8px 16px rgba(31, 240, 80, 0.2);
}

.login-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
  border-color: rgba(255, 255, 255, 0.2) !important;
  color: rgba(255, 255, 255, 0.4) !important;
  background: rgba(255, 255, 255, 0.05) !important;
}

/* Sign Up Link */
.sign-up-text-policy {
  font-family: "Darker Grotesque", sans-serif !important;
  font-size: 16px !important;
  color: rgba(255, 255, 255, 0.7) !important;
  text-align: center;
}

.link-accept-signup {
  font-family: "Darker Grotesque", sans-serif !important;
  font-size: 16px !important;
  color: #1ff050 !important;
  text-decoration: underline !important;
  text-decoration-style: solid !important;
  text-decoration-color: #1ff050 !important;
  text-underline-offset: 4px !important;
  cursor: pointer;
  transition: all 0.3s ease;
}

.link-accept-signup:hover {
  text-decoration-thickness: 2px !important;
  opacity: 0.8;
}

/* Footer Links */
.footer-links {
  margin-top: 32px;
  padding-top: 24px;
  border-top: 1px solid rgba(255, 255, 255, 0.1);
}

.footer-buttons-container {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 16px;
}

.footer-link-btn {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 8px 16px;
  background: transparent;
  border: 1px solid rgba(255, 255, 255, 0.15);
  border-radius: 8px;
  color: rgba(255, 255, 255, 0.7);
  font-family: "Darker Grotesque", sans-serif;
  font-weight: 500;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.3s ease;
  text-decoration: none;
  outline: none;
}

.footer-link-btn:hover {
  color: white;
  background: rgba(255, 255, 255, 0.08);
  border-color: rgba(255, 255, 255, 0.3);
  transform: translateY(-2px);
}

.footer-link-btn:active {
  transform: translateY(0);
}

.footer-link-icon {
  opacity: 0.8;
}

.separator-dot {
  width: 4px;
  height: 4px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.3);
}

/* Button Overlay Override */
:deep(.v-btn:hover) > .v-btn__overlay {
  --v-hover-opacity: 0;
  opacity: 0;
}

:deep(.v-btn[aria-haspopup=menu][aria-expanded=true]) > .v-btn__overlay {
  --v-hover-opacity: 0;
  opacity: 0;
}

:deep(.v-btn[aria-haspopup=menu][aria-expanded=true]:hover) > .v-btn__overlay {
  --v-hover-opacity: 0;
  opacity: 0;
}

/* Mobile Responsive */
@media (max-width: 768px) {
  .login-content-wrapper {
    padding: 120px 16px 60px 16px;
  }

  .typing-text {
    font-size: 24px;
  }

  .cursor {
    height: 24px;
  }

  .login-form-content {
    padding: 24px 20px !important;
  }

  .login-btn {
    font-size: 16px !important;
    padding: 20px !important;
  }

  .footer-links {
    margin-top: 24px;
    padding-top: 20px;
  }

  .footer-buttons-container {
    gap: 12px;
  }

  .footer-link-btn {
    padding: 6px 12px;
    font-size: 13px;
  }
}

@media (max-width: 480px) {
  .login-content-wrapper {
    padding: 80px 16px 60px 16px;
  }

  .typing-text {
    font-size: 20px;
  }

  .cursor {
    height: 20px;
  }

  .login-form-content {
    padding: 20px 16px !important;
  }

  .footer-buttons-container {
    flex-direction: column;
    gap: 8px;
  }

  .separator-dot {
    display: none;
  }

  .footer-link-btn {
    width: 100%;
    justify-content: center;
  }
}

/* Loading State for Button */
.login-btn :deep(.v-btn__loader) {
  color: #1ff050 !important;
}

/* Focus States */
.email-font :deep(.v-field--focused),
.password-font :deep(.v-field--focused) {
  box-shadow: 0 0 0 2px rgba(31, 240, 80, 0.2);
}

/* Error State */
.email-font :deep(.v-field--error .v-field__outline),
.password-font :deep(.v-field--error .v-field__outline) {
  color: #d32f2f !important;
}

.email-font :deep(.v-field--error .v-label),
.password-font :deep(.v-field--error .v-label) {
  color: #d32f2f !important;
}

/* Accessibility */
.login-btn:focus-visible {
  outline: 2px solid #1ff050;
  outline-offset: 2px;
}

.link-accept-signup:focus-visible {
  outline: 2px solid #1ff050;
  outline-offset: 2px;
  border-radius: 4px;
}

.footer-link-btn:focus-visible {
  outline: 2px solid rgba(255, 255, 255, 0.5);
  outline-offset: 2px;
}

/* Animation for Error Message */
@keyframes shake {
  0%, 100% { transform: translateX(0); }
  25% { transform: translateX(-10px); }
  75% { transform: translateX(10px); }
}

.login-error-alert {
  animation: shake 0.5s ease;
}

</style>